



























































































































import mixins from "vue-typed-mixins";
import { ProfileMixin } from "@/mixins/participant-general-mixin";
import SolidButton from "@/components/general/solid-button.vue";
import FormBody from "@/components/form/form-body.vue";
import FormModal from "@/components/general/form-modal.vue";

export default mixins(ProfileMixin).extend({
  name: "ParticipantProfile",
  components: {
    SolidButton,
    FormBody,
    FormModal,
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  methods: {
    async savePhoto(
      sectionId: number,
      itemId: number,
      field_ref: string,
      btnName: string
    ): Promise<void> {
      await this.$store.dispatch("toggleSnackbar", null);
      const file_name = await this.uploadFile(
        itemId,
        field_ref,
        btnName,
        0,
        1,
        false,
        ""
      );
      if (file_name !== false) {
        this.$store.commit("toggleButtonState", {
          name: btnName,
          status: true,
        });
        const value = this.getFormIndexes({
          sectionId: sectionId,
          itemId: itemId,
          itemVal: file_name,
          pageCounter: 0,
        });
        this.$store.commit("formRecord/updateItemVal", value);
        const response = await this.$store.dispatch(
          "formRecord/postActiveForm",
          true
        );
        if (response === true) {
          this.$store.commit("formRecord/updateActiveForm", {
            already_submitted: false,
          });
          await this.$store.dispatch("participantGeneral/getProfileInfo");
        }
        this.$store.commit("toggleButtonState", {
          name: btnName,
          status: false,
        });
      }
    },
  },
});
